import React, { Component } from 'react';
import _debounce from 'lodash.debounce';
import hoistNonReactStatics from 'hoist-non-react-statics';
function debounceRender(ComponentToDebounce, wait, debounceArgs) {
    class DebouncedContainer extends Component {
        constructor() {
            super(...arguments);
            this.updateDebounced = _debounce(this.forceUpdate, wait, debounceArgs);
        }
        shouldComponentUpdate() {
            this.updateDebounced();
            return false;
        }
        componentWillUnmount() {
            this.updateDebounced.cancel();
        }
        render() {
            return React.createElement(ComponentToDebounce, Object.assign({}, this.props));
        }
    }
    DebouncedContainer.displayName = `debounceRender(${ComponentToDebounce.displayName || ComponentToDebounce.name || 'Component'})`;
    return hoistNonReactStatics(DebouncedContainer, ComponentToDebounce);
}
;
export const debounce = (wait, debounceArgs) => (ComponentToDebounce) => debounceRender(ComponentToDebounce, wait, debounceArgs);
export default debounceRender;
